module.exports = __webpack_public_path__ + "static/icalendar_url_1-7be28eb1f0a688375ceba2a6c3a3c45b.png";